var formatId = function formatId(text) {
  return text.replace(/\s/g, "-").toLowerCase();
};
export default formatId;